import React from 'react'
import { useTranslation } from 'react-i18next'

import { Vehicle_TypeEnum, RetrieveVehicle_TypeEnum } from 'src/api/gen'
import { deviceColors } from 'src/theme'

import bicycleSvg from './bicycle.svg'
import cargoBikeSvg from './cargo_bike.svg'
import deliveryBotSvg from './delivery_bot.svg'
import mopedSvg from './moped.svg'
import otherSvg from './other.svg'
import pinBicyclePng from './pin_bicycle.png'
import pinCarPng from './pin_car.png'
import pinCargoBikePng from './pin_cargo_bike.png'
import pinDeliveryBotPng from './pin_delivery_bot.png'
import pinMopedPng from './pin_moped.png'
import pinOtherPng from './pin_other.png'
import pinScooterPng from './pin_scooter.png'
import scooterSvg from './scooter.svg'
import carSvg from './taxi.svg'

export const DEVICES_ICONS: Record<string, string> = {
  [Vehicle_TypeEnum.bicycle]: pinBicyclePng,
  [Vehicle_TypeEnum.car]: pinCarPng,
  [Vehicle_TypeEnum.delivery_bot]: pinDeliveryBotPng,
  [Vehicle_TypeEnum.moped]: pinMopedPng,
  [Vehicle_TypeEnum.other]: pinOtherPng,
  [Vehicle_TypeEnum.scooter]: pinScooterPng,
  [Vehicle_TypeEnum.cargo_bicycle]: pinCargoBikePng,
  [Vehicle_TypeEnum.scooter_seated]: pinScooterPng,
}

export const DEVICES_COLORS: Record<string, string> = {
  [Vehicle_TypeEnum.bicycle]: deviceColors.bicycle,
  [Vehicle_TypeEnum.car]: deviceColors.car,
  [Vehicle_TypeEnum.delivery_bot]: deviceColors.deliveryBot,
  [Vehicle_TypeEnum.moped]: deviceColors.moped,
  [Vehicle_TypeEnum.other]: deviceColors.other,
  [Vehicle_TypeEnum.scooter]: deviceColors.scooter,
  [Vehicle_TypeEnum.cargo_bicycle]: deviceColors.cargoBicycle,
  [Vehicle_TypeEnum.scooter_seated]: deviceColors.scooter,
}

interface IVehicleIconProps {
  className?: string
  size?: number
  style?: React.CSSProperties
}

const generateDeviceIcon = (deviceType: Vehicle_TypeEnum) => {
  return ({ size, style, className }: IVehicleIconProps) => {
    const { t } = useTranslation()
    let src = ''
    let title = deviceType as string
    switch (deviceType) {
      case Vehicle_TypeEnum.bicycle:
        src = bicycleSvg
        title = t('icon.bicycle')
        break
      case Vehicle_TypeEnum.car:
        src = carSvg
        title = t('icon.car')
        break
      case Vehicle_TypeEnum.cargo_bicycle:
        src = cargoBikeSvg
        title = t('icon.cargoBicycle')
        break
      case Vehicle_TypeEnum.delivery_bot:
        src = deliveryBotSvg
        title = t('icon.deliveryBot')
        break
      case Vehicle_TypeEnum.moped:
        src = mopedSvg
        title = t('icon.moped')
        break
      case Vehicle_TypeEnum.other:
        src = otherSvg
        title = t('icon.other')
        break
      case Vehicle_TypeEnum.scooter:
        src = scooterSvg
        title = t('icon.scooter')
        break
      case Vehicle_TypeEnum.scooter_seated:
        src = scooterSvg
        title = t('icon.scooter_seated')
    }
    const aggSize = size || 30
    const aggStyle = { width: aggSize, height: aggSize, ...(style || {}) }
    return <img src={src} title={title} style={aggStyle} className={className} />
  }
}

export const BicycleIcon = generateDeviceIcon(Vehicle_TypeEnum.bicycle)
const CarIcon = generateDeviceIcon(Vehicle_TypeEnum.car)
const CargoBicycleIcon = generateDeviceIcon(Vehicle_TypeEnum.cargo_bicycle)
const DeliveryBotIcon = generateDeviceIcon(Vehicle_TypeEnum.delivery_bot)
const MopedIcon = generateDeviceIcon(Vehicle_TypeEnum.moped)
const OtherIcon = generateDeviceIcon(Vehicle_TypeEnum.other)
const ScooterIcon = generateDeviceIcon(Vehicle_TypeEnum.scooter)

export const renderVehicleIcon = (category: RetrieveVehicle_TypeEnum, className: string, size?: number) => {
  switch (category) {
    case RetrieveVehicle_TypeEnum.bicycle:
      return <BicycleIcon style={{ color: 'white' }} size={size} className={className} />
    case RetrieveVehicle_TypeEnum.car:
      return <CarIcon size={size} className={className} />
    case RetrieveVehicle_TypeEnum.cargo_bicycle:
      return <CargoBicycleIcon size={size} className={className} />
    case RetrieveVehicle_TypeEnum.delivery_bot:
      return <DeliveryBotIcon size={size} className={className} />
    case RetrieveVehicle_TypeEnum.moped:
      return <MopedIcon size={size} className={className} />
    case RetrieveVehicle_TypeEnum.other:
      return <OtherIcon size={size} className={className} />
    case RetrieveVehicle_TypeEnum.scooter:
      return <ScooterIcon size={size} className={className} />
    case RetrieveVehicle_TypeEnum.scooter_seated:
      return <ScooterIcon size={size} className={className} />
  }
}
